import React from 'react'

type Props = {
  name?: string | null
  logoImageUrl?: string | null
  size?: number
  className?: string
}

function monogram(name?: string | null): string {
  const raw = String(name || '').trim()
  if (!raw) return 'B'
  const parts = raw.split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase()
}

export default function BusinessAvatar({ name, logoImageUrl, size = 48, className = '' }: Props) {
  const initials = monogram(name)
  const style = { width: size, height: size }
  if (logoImageUrl) {
    return (
      <div style={style} className={`overflow-hidden rounded-full border border-white/20 bg-black/30 ${className}`}>
        <img src={logoImageUrl} alt={name || 'Business logo'} className="h-full w-full object-cover" />
      </div>
    )
  }
  return (
    <div
      style={style}
      className={`flex items-center justify-center rounded-full border border-white/20 bg-gradient-to-br from-slate-700/70 to-slate-900/70 text-white font-semibold ${className}`}
      aria-label={name || 'Business avatar'}
      title={name || 'Business'}
    >
      <span style={{ fontSize: Math.max(12, Math.floor(size * 0.34)) }}>{initials}</span>
    </div>
  )
}
